import { DetailsService } from './../../service/details.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-premium-single',
  templateUrl: './premium-single.component.html',
  styleUrls: ['./premium-single.component.css']
})
export class PremiumSingleComponent implements OnInit {

  constructor(private route: ActivatedRoute, private details: DetailsService) { }
  orderId: any;
  seasons: any = [];
  episodes: any = [];
  totalprice: any = 0;
  user: any;
  ngOnInit() {
    this.route.params.subscribe(params => {

      this.orderId = params['id'];
      this.details.getSingleOrderDate(this.orderId).then(singledata => {
        singledata.subscribe(cartdatas => {
          if (cartdatas['length']) {
            this.details.getsingleuse(cartdatas[0]['userid']).subscribe(data =>{
              this.user = data;
            });
          }
          cartdatas.forEach(element => {
            if (element['full_season']) {
              this.seasons.push(element);
              this.totalprice += parseInt(element['price'])
            } else {
              for (let i of element['episodes']) {
                i.expiredate = element['expiredate'];
                i.createdAt = element['createdAt'];
                this.episodes = this.episodes.concat(i);
                this.totalprice += parseInt(i.prices.episodeprice)
              }
            }
          });
       
        });
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/premium/premium-single/premium-single.component.ts